import DashboardCard from '../../shared/DashboardCard';
import { CORE_SERVICES, CORE_SERVICES_SECTION } from '../../constants';
import { ServicesStack, CtaButtonContainer } from './styles';
import { BottomText, SectionTitle, Subtext } from '../../../shared/styles';
import CtaButton from '../../../../../ui/ctaButton';
import { Gapper } from '../../../../../ui/utils';
import { openSimplePracticeConsultation } from '../../../../../utils/simplePractice';

const CoreServicesSection = () => {
  const handleBookConsultation = () => {
    openSimplePracticeConsultation();
  };
  return (
    <Gapper gap={0}>
      <SectionTitle variant="h3">{CORE_SERVICES_SECTION.title}</SectionTitle>
      <Subtext align="center">{CORE_SERVICES_SECTION.subtext}</Subtext>

      <ServicesStack>
        {CORE_SERVICES.map((service, index) => (
          <DashboardCard
            key={index}
            title={service.title}
            subTitle={service.subTitle}
            description={service.description}
            image={service.image}
            reverse={service.reverse}
          />
        ))}
      </ServicesStack>
      <BottomText align="center">{CORE_SERVICES_SECTION.bottomText}</BottomText>
      <CtaButtonContainer>
        <CtaButton text={CORE_SERVICES_SECTION.buttonText} onClick={handleBookConsultation} />
      </CtaButtonContainer>
    </Gapper>
  );
};

export default CoreServicesSection;
